
import React, { useState, useEffect } from "react";
import axios from "axios";
import Profile from "../../components/Profile/Profile";
import AddProfile from "../../components/AddProfile/AddProfile";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import EmployeeList from "../../components/EmployeeList/EmployeeList";
import MasterTopButtons from "../../components/MasterTopButtons/MasterTopButtons";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PaginationLink from "../../components/Pagination/Pagination";
import FilterEmployeeData from "../../components/FilterEmployeeData/FilterEmployeeData";

function EmployeeMaster() {
  const [userDetailResponse, setUserDetailResponse] = useState(null);
  const [filteredEmployees, setFilteredEmployees] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [filterCityData, setFilterCityData] = useState(false); // Controls visibility of the filter
  const [selectedEmployeeId, setSelectedEmployeeId] = useState();
  const [departments, setDepartments] = useState(null);
  const [region, setRegion] = useState(null);
  const [locations, setLocations] = useState(null);
  const [employeeResponse, setEmployeeResponse] = useState(null);
  const [filterEmployeeData, setFilterEmployeeData] = useState(false);
  const [recordCountfilter, setRecordCountfilter] = useState(0);



  const [recordCount, setRecordCount] = useState(0);

  const baseAPI = process.env.REACT_APP_API_URL;
  const title = "Add Employees";
  const heading = "Employee List";





  function tokenStorage() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETEmployee?employeeID=&desg_id=0&dept_id=0&region_id=0&meal_Preference=&status=&location=`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          // console.log("employeresponse",response)
          setUserDetailResponse(response.data.data);
          setFilteredEmployees(response.data.data);
          if (response.data.data) {
            setRecordCount(response.data.data.length);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }

    if (openAddProfile) {
      setOpenProfile(false);
    } else if (openProfile) {
      setOpenAddProfile(false);
    }
  }

  function setDepartment() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETDepartment?department=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setDepartments(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  function setLocation() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GetEmpLocation`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setLocations(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }


  useEffect(() => {
    tokenStorage();
    setDepartment();
    setRegions();
    setLocation();
  }, [successMessage, openAddProfile, setOpenProfile, openProfile, setOpenAddProfile,]);



  const GetId = (param) => {
    setSelectedEmployeeId(param);
  };


  function setRegions() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETRegion?region_id=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setRegion(response.data.data);
          // console.log("region in master",region)
          // console.log("region in master",response)

        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }




  // console.log("region in master",region)

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Employee Master | <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Master</span>
                </h1>
              </div>
              <div style={{ width: "8rem" }}>
                <select className="form-control" name="country">
                  <option value="0">INDIA</option>
                  <option value="1">DUBAI</option>
                </select>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                <MasterTopButtons
                  title={title}
                  heading={heading}
                  setOpenAddProfile={setOpenAddProfile}
                  openAddProfile={openAddProfile}
                  setOpenProfile={setOpenProfile}
                  setFilterCityData={setFilterCityData}
                  filterCityData={filterCityData}
                  isEmployeeMasterPage={true}
                  recordCount={recordCount} />
                {filterCityData && (


                  <FilterEmployeeData
                    setUserDetailResponse={setFilteredEmployees}
                    setRecordCount={setRecordCount}
                    departments={departments}
                    region={region}
                    filterCityData={filterCityData}
                    setFilterCityData={setFilterCityData}
                    
                  />


                )}
                {openAddProfile ? (
                  <AddProfile
                    tokenStorage={tokenStorage}
                    openAddProfile={openAddProfile}
                    setOpenAddProfile={setOpenAddProfile}
                    successMessage={successMessage}
                    setSuccessMessage={setSuccessMessage}
                  />
                ) : null}
                {openProfile ? (
                  <Profile
                    tokenStorage={tokenStorage}
                    openProfile={openProfile}
                    setOpenProfile={setOpenProfile}
                    selectedEmployeeId={selectedEmployeeId}
                    successMessage={successMessage}
                    setSuccessMessage={setSuccessMessage}
                  />
                ) : null}

                <EmployeeList
                  userDetailResponse={filteredEmployees} // Pass the filtered employees
                  setOpenProfile={setOpenProfile}
                  openProfile={openProfile}
                  GetId={GetId}
                  openAddProfile={openAddProfile}
                  setOpenAddProfile={setOpenAddProfile}
                />



                <PaginationLink />
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EmployeeMaster;

